import React from 'react';

import styles from './ActionGroup.module.css';

export default function ActionGroup({children, align}) {
  const classes = [styles.actionGroup];
  if (align === 'right') {
    classes.push(styles.rightAlign);
  }
  return (
    <div className={classes.join(' ')}>
      {React.Children.map(children, (child) => (
        <div className={styles.actionContainer}>{child}</div>
      ))}
    </div>
  );
}
